import {
  DateTimePeriodResponse,
  GetOutlookAppointmentResponse,
} from "@/out-look/services/outlook-appointment-service/models";

export class OutLookInfo {
  uid: string | null;
  isReopenAfterSent?: boolean;
  sessionId?: string;
  startTimeTicks: number | null;
  endTimeTicks: number | null;
  start: Date | null;
  end: Date | null;
  subject: string | null;
  timeZoneStandardName?: string;
  guid: string | null;
  globalId: string | null;
  isRecurringMaster?: boolean;
  isNoEndDate?: boolean;
  occurrences: DateTimePeriod[] | null;
  itemId?: string | null;
  isOccurence?: boolean;
  originalStart: string | null;
  originalEnd: string | null;
  recurringAppDuration?: string;
  haveOrder: boolean;
  haveNormalOrder: boolean;
  startInOrgTz?: Date;
  endInOrgTz?: Date;
  startTimeNotConvert?: Date | null;
  endTimeNotConvert?: Date| null;
  displayStartTime?: Date | null;
  displayEndTime?: Date | null;
  isReOpen?: boolean;

  constructor(data?: GetOutlookAppointmentResponse) {
    this.uid = data?.Uid || null;
    this.isReopenAfterSent = !!data?.IsReopenAfterSent;
    this.sessionId = data?.SessionId || undefined;
    this.startTimeTicks = data?.StartTimeTicks || null;
    this.endTimeTicks = data?.EndTimeTicks || null;
    this.start = data?.Start || null;
    this.end = data?.End || null;
    this.subject = data?.Subject || null;
    this.guid = data?.Guid || null;
    this.globalId = data?.GlobalId || null;
    this.isRecurringMaster = !!data?.IsRecurringMaster;
    this.isNoEndDate = !data?.IsNoEndDate;
    this.occurrences = data?.Occurrences
      ? data.Occurrences.map(
          (item: DateTimePeriodResponse) => new DateTimePeriod(item)
        )
      : null;
    this.itemId = data?.ItemId || null;
    this.isOccurence = !!data?.IsOccurence;
    this.originalStart = data?.OriginalStart || null;
    this.originalEnd = data?.OriginalEnd || null;
    this.recurringAppDuration = data?.RecurringAppDuration || undefined;
    this.haveOrder = !!data?.HaveOrder;
    this.haveNormalOrder = !!data?.HaveNormalOrder;
    this.startInOrgTz = data?.StartInOrgTz || undefined;
    this.endInOrgTz = data?.EndInOrgTz || undefined;
    this.startTimeNotConvert = data?.StartTimeNotConvert || data?.Start;
    this.endTimeNotConvert = data?.EndTimeNotConvert || data?.End;
    this.displayStartTime = data?.DisplayStartTime || data?.Start;
    this.displayEndTime = data?.DisplayEndTime || data?.Start;
    this.isReOpen = data?.IsReOpen;
  }

  toJson(): GetOutlookAppointmentResponse {
    return {
      Uid: this.uid || "",
      IsReopenAfterSent: this.isReopenAfterSent,
      SessionId: this.sessionId || "",
      StartTimeTicks: this.startTimeTicks || 0,
      EndTimeTicks: this.endTimeTicks || 0,
      Start: this.start || new Date(),
      End: this.end || new Date(),
      Subject: this.subject || "",
      TimeZoneStandardName: this.timeZoneStandardName || undefined,
      Guid: this.guid || "",
      GlobalId: this.globalId || "",
      IsRecurringMaster: this.isRecurringMaster,
      IsNoEndDate: this.isNoEndDate,
      Occurrences: (this.occurrences || []).map((item: DateTimePeriod) => item.toJson()),
      ItemId: this.itemId || undefined,
      IsOccurence: this.isOccurence,
      OriginalStart: this.originalStart || "",
      OriginalEnd: this.originalEnd || "",
      RecurringAppDuration: this.recurringAppDuration || "",
      HaveOrder: this.haveOrder,
      HaveNormalOrder: this.haveNormalOrder,
      StartInOrgTz: this.startInOrgTz,
      EndInOrgTz: this.endInOrgTz,
      DisplayStartTime: this.displayStartTime,
      DisplayEndTime: this.displayEndTime,
      StartTimeNotConvert: this.startTimeNotConvert,
      EndTimeNotConvert: this.endTimeNotConvert
    };
  }
}

export class DateTimePeriod {
  startTicks: number | null;
  endTicks: number | null;
  start?: Date | null;
  end?: Date | null;

  constructor(data?: DateTimePeriodResponse) {
    this.startTicks = data?.StartTicks || null;
    this.endTicks = data?.EndTicks || null;
    this.start = data?.Start || null;
    this.end = data?.End || null;
  }

  toJson(): DateTimePeriodResponse {
    return {
      StartTicks: this.startTicks || 0,
      EndTicks: this.endTicks || 0,
      Start: this.start || undefined,
      End: this.end || undefined,
    };
  }
}
